import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const Container = styled.div`
  align-self: center;
  justify-self: center;
  padding: ${({ padding }) => `${padding || '4rem'} 0`};
  text-align: center;

  i {
    font-size: 2rem;
  }
`;

export default ({ padding }) => (
  <Container padding={padding}>
    <Icon spin name="refresh" />
  </Container>
);
